import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, pgTable, primaryKey, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Keyword } from '../../keyword'
import { Lesson } from './lesson'

export const LessonToKeyword = pgTable(
  'lesson_to_keyword',
  {
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    keywordId: uuid()
      .notNull()
      .references(() => Keyword.id, { onDelete: 'cascade' }),
  },
  (table) => [
    primaryKey({ columns: [table.lessonId, table.keywordId] }),
    index('lesson_to_keyword_lesson_idx').on(table.lessonId),
    index('lesson_to_keyword_keyword_idx').on(table.keywordId),
  ],
)

export const lessonToKeywordRelations = relations(LessonToKeyword, ({ one }) => ({
  lesson: one(Lesson, {
    fields: [LessonToKeyword.lessonId],
    references: [Lesson.id],
  }),
  keyword: one(Keyword, {
    fields: [LessonToKeyword.keywordId],
    references: [Keyword.id],
  }),
}))

export const InsertLessonToKeywordSchema = createInsertSchema(LessonToKeyword)
export const UpdateLessonToKeywordSchema = createUpdateSchema(LessonToKeyword).partial()
export const SelectLessonToKeywordSchema = createSelectSchema(LessonToKeyword)

export type InsertLessonToKeyword = typeof LessonToKeyword.$inferInsert
export type UpdateLessonToKeyword = z.infer<typeof UpdateLessonToKeywordSchema>
export type SelectLessonToKeyword = typeof LessonToKeyword.$inferSelect
